import { useContext } from 'react';
import { GetUserContext } from '../context';
/**
 * Custom React Hook that returns the `GetUserContext` value
 */
var useGetUser = function () { return useContext(GetUserContext); };
export default useGetUser;
//# sourceMappingURL=useGetUser.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hilma/auth/dist/hooks/useGetUser.js
// module id = 125
// module chunks = 1